<template>
  <div v-if="current">

    <v-card width="100%">
      <v-card-title>Dados do registro</v-card-title>
      <v-card-text>
        <v-form>
          <div class="row">
            <div class="col-md-4 col-sm-1">
              <div class="d-flex align-center">
                <v-text-field
                  label="Cliente"
                  v-model="current.clientName"
                  outlined
                  dense
                  disabled
                  hide-details
                ></v-text-field>
                <v-btn icon small class="ml-1" @click="toggleClient" title="Dados do cliente">
                  <v-icon>{{ showClient ? "mdi-chevron-up" : "mdi-chevron-down" }}</v-icon>
                </v-btn>
              </div>
            </div>
            <div class="col-md-4 col-sm-1">
              <v-text-field
                label="Plano"
                v-model="current.planName"
                outlined
                dense
                disabled
                hide-details
              ></v-text-field>
            </div>
            <div class="col-md-4 col-sm-1">
              <v-select
                label="Status"
                v-model="current.status"
                :items="status"
                outlined
                dense
                disabled
                hide-details
              ></v-select>
            </div>

            <v-expand-transition>
              <div class="col-md-12 col-sm-1" v-show="showClient" v-if="clientDetails">
                <v-sheet elevation="5" class="pa-4">
                  <div class="d-flex align-center mb-2">
                    <v-icon left>mdi-account-box</v-icon>
                    <span class="subtitle-1">Dados do Cliente</span>
                    <v-spacer></v-spacer>
                    <v-btn
                      small
                      text
                      color="primary"
                      :href="$router.resolve(`/client/${current.clientId}`).href"
                      target="_blank"
                    >
                      <v-icon left small>mdi-open-in-new</v-icon>Abrir cadastro
                    </v-btn>
                  </div>
                  <div class="row">
                    <div class="col-md-3 col-sm-1">
                      <v-text-field
                        label="CPF/CNPJ"
                        v-model="clientDetails.register"
                        outlined
                        dense
                        disabled
                        hide-details
                      ></v-text-field>
                    </div>
                    <div class="col-md-3 col-sm-1">
                      <v-text-field
                        label="Telefone"
                        v-model="clientDetails.telephone"
                        outlined
                        dense
                        disabled
                        hide-details
                      ></v-text-field>
                    </div>
                    <div class="col-md-3 col-sm-1">
                      <v-text-field
                        label="Celular"
                        v-model="clientDetails.cellphone"
                        outlined
                        dense
                        disabled
                        hide-details
                      ></v-text-field>
                    </div>
                    <div class="col-md-3 col-sm-1">
                      <v-text-field
                        label="Email"
                        v-model="clientDetails.email"
                        outlined
                        dense
                        disabled
                        hide-details
                      ></v-text-field>
                    </div>
                    <div class="col-md-6 col-sm-1">
                      <v-text-field
                        label="Logradouro"
                        v-model="clientDetails.address"
                        outlined
                        dense
                        disabled
                        hide-details
                      ></v-text-field>
                    </div>
                    <div class="col-md-2 col-sm-1">
                      <v-text-field
                        label="Número"
                        v-model="clientDetails.addressNumber"
                        outlined
                        dense
                        disabled
                        hide-details
                      ></v-text-field>
                    </div>
                    <div class="col-md-2 col-sm-1">
                      <v-text-field
                        label="Complemento"
                        v-model="clientDetails.addressExtra"
                        outlined
                        dense
                        disabled
                        hide-details
                      ></v-text-field>
                    </div>
                    <div class="col-md-2 col-sm-1">
                      <v-text-field
                        label="Bairro"
                        v-model="clientDetails.addressNeighborhood"
                        outlined
                        dense
                        disabled
                        hide-details
                      ></v-text-field>
                    </div>
                    <div class="col-md-4 col-sm-1">
                      <v-text-field
                        label="Cidade"
                        v-model="clientDetails.city"
                        outlined
                        dense
                        disabled
                        hide-details
                      ></v-text-field>
                    </div>
                    <div class="col-md-2 col-sm-1">
                      <v-text-field
                        label="Estado"
                        v-model="clientDetails.province"
                        outlined
                        dense
                        disabled
                        hide-details
                      ></v-text-field>
                    </div>
                    <div class="col-md-3 col-sm-1">
                      <v-text-field
                        label="País"
                        v-model="clientDetails.country"
                        outlined
                        dense
                        disabled
                        hide-details
                      ></v-text-field>
                    </div>
                    <div class="col-md-3 col-sm-1">
                      <v-text-field
                        label="CEP"
                        v-model="clientDetails.zipcode"
                        outlined
                        dense
                        disabled
                        hide-details
                      ></v-text-field>
                    </div>
                  </div>
                </v-sheet>
              </div>
            </v-expand-transition>

            <div class="col-md-3 col-sm-1">
              <v-text-field
                label="Número"
                v-model="current.number"
                outlined
                dense
                disabled
                hide-details
              ></v-text-field>
            </div>
            <div class="col-md-3 col-sm-1">
              <v-text-field
                label="Senha"
                v-model="current.password"
                outlined
                dense
                disabled
                hide-details
              ></v-text-field>
            </div>
            <div class="col-md-3 col-sm-1">
              <v-text-field
                label="IP/Host"
                v-model="current.ipaddr"
                outlined
                dense
                disabled
                hide-details
              ></v-text-field>
            </div>
            <div class="col-md-3 col-sm-1">
              <v-text-field
                label="Porta"
                v-model="current.ipport"
                outlined
                dense
                disabled
                hide-details
              ></v-text-field>
            </div>
            <div class="col-md-2 col-sm-1">
              <v-text-field
                label="Código do País"
                v-model="current.countryCode"
                outlined
                dense
                disabled
                hide-details
              ></v-text-field>
            </div>
            <div class="col-md-2 col-sm-1">
              <v-text-field
                label="Código de Area"
                v-model="current.areaCode"
                outlined
                dense
                disabled
                hide-details
              ></v-text-field>
            </div>
            <div class="col-md-2 col-sm-1">
              <v-text-field
                label="CLI"
                v-model="current.cli"
                outlined
                dense
                disabled
                hide-details
              ></v-text-field>
            </div>
            <div class="col-md-2 col-sm-1">
              <v-select
                label="Discagem"
                v-model="current.dialplan"
                :items="dialplans"
                outlined
                dense
                disabled
                hide-details
              ></v-select>
            </div>
            <div class="col-md-2 col-sm-1">
              <v-select
                label="ACL"
                v-model="current.acl"
                :items="acls"
                outlined
                dense
                disabled
                hide-details
              ></v-select>
            </div>
            <div class="col-md-2 col-sm-1">
              <v-text-field
                label="Canais"
                v-model="current.channels"
                outlined
                dense
                disabled
                hide-details
              ></v-text-field>
            </div>
            <div class="col-md-3 col-sm-1">
              <v-select
                label="Bloqueio Voip"
                v-model="current.blockVoip"
                :items="blocks"
                outlined
                dense
                disabled
                hide-details
              ></v-select>
            </div>
            <div class="col-md-3 col-sm-1">
              <v-select
                label="Bloqueio Fixo"
                v-model="current.blockLandline"
                :items="blocks"
                outlined
                dense
                disabled
                hide-details
              ></v-select>
            </div>
            <div class="col-md-3 col-sm-1">
              <v-select
                label="Bloqueio Móvel"
                v-model="current.blockMobile"
                :items="blocks"
                outlined
                dense
                disabled
                hide-details
              ></v-select>
            </div>
            <div class="col-md-3 col-sm-1">
              <v-select
                label="Bloqueio Internacional"
                v-model="current.blockInternational"
                :items="blocks"
                outlined
                dense
                disabled
                hide-details
              ></v-select>
            </div>
            <div class="col-md-3 col-sm-1">
              <v-text-field
                label="Mensalidade"
                v-model="current.monthly"
                outlined
                dense
                disabled
                hide-details
              ></v-text-field>
            </div>
            <div class="col-md-3 col-sm-1">
              <v-select
                label="Tipo de Faturamento"
                v-model="current.invoiceType"
                :items="invoice"
                outlined
                dense
                disabled
                hide-details
              ></v-select>
            </div>
            <div class="col-md-3 col-sm-1">
              <v-text-field
                label="Data de Instalação"
                v-model="computedSetup"
                outlined
                dense
                disabled
                hide-details
              ></v-text-field>
            </div>
            <div class="col-md-3 col-sm-1">
                <v-text-field
                  label="Máximo de Registros"
                  v-model="current.maxregs"
                  outlined
                  dense
                  disabled
                  hide-details
                ></v-text-field>
              </div>
            <div class="col-md-12 col-sm-1">
              <v-textarea
                label="Observação"
                v-model="current.obs"
                outlined
                dense
                disabled
                hide-details
              ></v-textarea>
            </div>
          </div>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <div>
        <v-btn v-if="current.status != 0" color="success" @click="dialogEnable()" class="ma-2">Habilitar</v-btn>
        <v-btn v-if="current.status != 4" color="secondary" @click="dialogCancel()" class="ma-2">Cancelar</v-btn>
        <v-btn v-if="current.status == 0" color="primary" @click="dialogClient()" class="ma-2">Mudança de Titularidade</v-btn>
        <v-btn v-if="current.status == 0" color="primary" @click="dialogPlan()" class="ma-2">Mudança de Plano</v-btn>
        <v-btn v-if="current.status == 0" color="primary" @click="dialogAuth()" class="ma-2">Alterar autenticação</v-btn>
        <v-btn v-if="current.status == 0" color="primary" @click="dialogDisc()" class="ma-2">Alterar discagem</v-btn>
        <v-btn v-if="current.status == 0" color="primary" @click="dialogACL()" class="ma-2">Alterar ACL</v-btn>
        <v-btn v-if="current.status == 0" color="primary" @click="dialogBlocks()" class="ma-2">Alterar bloqueios</v-btn>
        <v-btn v-if="current.status == 0" color="primary" @click="dialogChannels()" class="ma-2">Alterar canais</v-btn>
        <v-btn v-if="current.status == 0" color="primary" @click="dialogMonthly()" class="ma-2">Alterar mensalidade</v-btn>
        <v-btn v-if="current.status == 0" color="primary" @click="dialogFat()" class="ma-2">Alterar Faturamento</v-btn>
        <v-btn v-if="current.status == 0" color="primary" @click="dialogMaxregs()" class="ma-2">Alterar registros</v-btn>
        <v-btn v-if="current.status == 0" color="primary" @click="dialogObs()" class="ma-2">Alterar observação</v-btn>
        </div>
      </v-card-actions>
    </v-card>

    <v-dialog v-model="dialog_client" max-width="500px">
      <v-card>
        <v-card-title>Mudança de Titular</v-card-title>
        <v-card-text>
          <v-autocomplete label="Cliente" v-model="changed.clientId" :search-input.sync="searchClient" :items="clients"
            item-text="name" item-value="id" outlined dense></v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" @click="putClient()">Salvar</v-btn>
          <v-btn color="default" @click="dialog_client = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_plan" max-width="500px">
      <v-card>
        <v-card-title>Mudança de Plano</v-card-title>
        <v-card-text>
          <v-autocomplete label="Plano" v-model="changed.planId" :search-input.sync="searchPlan" :items="plans"
            item-text="name" item-value="id" outlined dense></v-autocomplete>
          <v-text-field label="Mensalidade" v-model="changed.monthly" outlined dense></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" @click="putPlan()">Salvar</v-btn>
          <v-btn color="default" @click="dialog_plan = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_enable" max-width="500px">
      <v-card>
        <v-card-title>Habilitar</v-card-title>
        <v-card-text>
          Tem certeza que deseja habilitar a linha?
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" @click="putEnable()">Habilitar</v-btn>
          <v-btn color="default" @click="dialog_enable = false">Desistir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_cancel" max-width="500px">
      <v-card>
        <v-card-title>Cancelar</v-card-title>
        <v-card-text>
          Tem certeza que deseja cancelar a linha?
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="putCancel()">Cancelar</v-btn>
          <v-btn color="default" @click="dialog_cancel = false">Desitir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_auth" max-width="500px">
      <v-card>
        <v-card-title>Alterar Autenticação</v-card-title>
        <v-card-text>
          <div class="col-md-12 col-sm-1">
            <v-text-field
              label="IP/Host"
              v-model="changed.ipaddr"
              outlined
              dense
            ></v-text-field>
          </div>
          <div class="col-md-12 col-sm-1">
            <v-text-field
              label="Porta"
              v-model="changed.ipport"
              outlined
              dense
            ></v-text-field>
          </div>
          <div class="col-md-12 col-sm-1">
            <v-text-field
              label="Número"
              v-model="changed.number"
              outlined
              dense
            ></v-text-field>
          </div>
          <div class="col-md-12 col-sm-1">
            <v-text-field
              label="Senha"
              v-model="changed.password"
              outlined
              dense
            ></v-text-field>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" @click="putAuth()">Salvar</v-btn>
          <v-btn color="default" @click="dialog_auth = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_disc" max-width="500px">
      <v-card>
        <v-card-title>Alterar discagem</v-card-title>
        <v-card-text>
          <div class="col-md-12 col-sm-1">
            <v-text-field
              label="Código do País"
              v-model="changed.countryCode"
              outlined
              dense
            ></v-text-field>
          </div>
          <div class="col-md-12 col-sm-1">
            <v-text-field
              label="Código de Area"
              v-model="changed.areaCode"
              outlined
              dense
            ></v-text-field>
          </div>
          <div class="col-md-12 col-sm-1">
            <v-text-field
              label="CLI"
              v-model="changed.cli"
              outlined
              dense
            ></v-text-field>
          </div>
          <div class="col-md-12 col-sm-1">
            <v-select
              label="Discagem"
              v-model="changed.dialplan"
              :items="dialplans"
              outlined
              dense
            ></v-select>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" @click="putDisc()">Salvar</v-btn>
          <v-btn color="default" @click="dialog_disc = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_acl" max-width="500px">
      <v-card>
        <v-card-title>Alterar ACL</v-card-title>
        <v-card-text>
          <div class="col-md-12 col-sm-1">
            <v-select
                label="ACL"
                v-model="changed.acl"
                :items="acls"
                outlined
                dense
              ></v-select>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" @click="putACL()">Salvar</v-btn>
          <v-btn color="default" @click="dialog_acl = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_blocks" max-width="500px">
      <v-card>
        <v-card-title>Alterar bloqueios</v-card-title>
        <v-card-text>
          <div class="col-md-12 col-sm-1">
            <v-select
                label="Bloqueio Voip"
                v-model="changed.blockVoip"
                :items="blocks"
                outlined
                dense
              ></v-select>
          </div>
          <div class="col-md-12 col-sm-1">
            <v-select
                label="Bloqueio Fixo"
                v-model="changed.blockLandline"
                :items="blocks"
                outlined
                dense
              ></v-select>
          </div>
          <div class="col-md-12 col-sm-1">
            <v-select
                label="Bloqueio Móvel"
                v-model="changed.blockMobile"
                :items="blocks"
                outlined
                dense
              ></v-select>
          </div>
          <div class="col-md-12 col-sm-1">
            <v-select
                label="Bloqueio Internacional"
                v-model="changed.blockInternational"
                :items="blocks"
                outlined
                dense
              ></v-select>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" @click="putBlocks()">Salvar</v-btn>
          <v-btn color="default" @click="dialog_blocks = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_fat" max-width="500px">
      <v-card>
        <v-card-title>Alterar tipo de faturamento</v-card-title>
        <v-card-text>
          <div class="col-md-12 col-sm-1">
            <v-select
                label="Tipo de Faturamento"
                v-model="changed.invoiceType"
                :items="invoice"
                outlined
                dense
              ></v-select>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" @click="putFat()">Salvar</v-btn>
          <v-btn color="default" @click="dialog_fat = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <v-dialog v-model="dialog_monthly" max-width="500px">
      <v-card>
        <v-card-title>Alterar mensalidade</v-card-title>
        <v-card-text>
          <div class="col-md-12 col-sm-1">
            <v-text-field
              label="Mensalidade"
              v-model="changed.monthly"
              outlined
              dense
            ></v-text-field>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" @click="putMonthly()">Salvar</v-btn>
          <v-btn color="default" @click="dialog_monthly = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_channels" max-width="500px">
      <v-card>
        <v-card-title>Alterar canais</v-card-title>
        <v-card-text>
          <div class="col-md-12 col-sm-1">
            <v-text-field
              label="Canais"
              v-model="changed.channels"
              outlined
              dense
            ></v-text-field>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" @click="putChannels()">Salvar</v-btn>
          <v-btn color="default" @click="dialog_channels = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_maxregs" max-width="500px">
      <v-card>
        <v-card-title>Alterar Máximo de Registros</v-card-title>
        <v-card-text>
          <div class="col-md-12 col-sm-1">
            <v-text-field
              label="Máximo de Registros"
              v-model="changed.maxregs"
              outlined
              dense
            ></v-text-field>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" @click="putMaxregs()">Salvar</v-btn>
          <v-btn color="default" @click="dialog_maxregs = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_obs" max-width="500px">
      <v-card>
        <v-card-title>Alterar observação</v-card-title>
        <v-card-text>
          <div class="col-md-12 col-sm-1">
            <v-textarea
              label="Observação"
              v-model="changed.obs"
              outlined
              dense
            ></v-textarea>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" @click="putObs()">Salvar</v-btn>
          <v-btn color="default" @click="dialog_obs = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_loading" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Por favor aguarde
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" timeout="3000" color="success">
      Salvo com sucesso!
    </v-snackbar>

  </div>
</template>

<script>
import api from "../../api/index.js";
export default {
  data: () => ({
    current: null,
    status: [
      { value: 0, text: "Habilitado" },
      { value: 1, text: "Bloqueado administrador" },
      { value: 2, text: "Bloqueado cliente" },
      { value: 3, text: "Bloqueado pagamento" },
      { value: 4, text: "Cancelado" },
    ],
    invoice: [
      { value: 1, text: "Mensalidade + Consumo" },
      { value: 2, text: "Mensalidade apenas" },
      { value: 3, text: "Consumo apenas" }
    ],
    dialplans: [
      { value: "union-ss", text: "Padrão" }
    ],
    acls: [
      { value: "all", text: "Qualquer IP" },
      { value: "br", text: "Apenas IPs do Brasil" }
    ],
    blocks: [
      { value: true, text: "Habilitado" },
      { value: false, text: "Desabilitado" }
    ],
    changed: {},
    showClient: false,
    clientDetails: null,
    snackbar: false,
    clients: [],
    searchClient: null,
    plans: [],
    searchPlan: null,
    dialog_loading: false,
    dialog_client: false,
    dialog_plan: false,
    dialog_enable: false,
    dialog_cancel: false,
    dialog_auth: false,
    dialog_acl: false,
    dialog_monthly: false,
    dialog_channels: false,
    dialog_fat: false,
    dialog_maxregs: false,
    dialog_blocks: false,
    dialog_obs: false,
    dialog_disc: false
  }),
  created: function () {
    this.load();
  },
  methods: {
    load: function () {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .get("/sipline/" + this.$route.params.id, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.current = response.data;
          me.loadClient();
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao recuperar registro!");
          console.log(error);
        });
    },
    toggleClient: function () {
      this.showClient = !this.showClient;
    },
    loadClient: function () {
      var me = this;
      var token = localStorage.getItem("token");
      api
        .get("/client/" + this.current.clientId, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.clientDetails = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    dialogPlan: function () {
      this.plans = [{ id: this.current.planId, name: this.current.planName }];
      this.changed.planId = this.current.planId;
      this.changed.monthly = this.current.monthly;
      this.dialog_plan = true;
    },
    putPlan: function () {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .put("/sipline/plan/" + this.$route.params.id, this.changed, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.dialog_plan = false;
          me.snackbar = true;
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao salvar plano!");
          console.log(error);
        });
    },
    dialogClient: function () {
      this.clients = [{ id: this.current.clientId, name: this.current.clientName }];
      this.changed.clientId = this.current.clientId;
      this.dialog_client = true;
    },
    putClient: function () {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .put("/sipline/client/" + this.$route.params.id, this.changed, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.dialog_client = false;
          me.snackbar = true;
          me.current = response.data;
          me.loadClient();
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao salvar cliente!");
          console.log(error);
        });
    },
    dialogEnable: function(){
      this.changed.status = 0;
      this.dialog_enable = true;
    },
    putEnable: function(){
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .put("/sipline/enable/" + this.$route.params.id, this.changed, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.dialog_enable = false;
          alert("Habilitado com sucesso!");
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao habilitar!");
          console.log(error);
        });
    },
    dialogCancel: function(){
      this.changed.status = 4;
      this.dialog_cancel = true;
    },
    putCancel: function(){
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .put("/sipline/cancel/" + this.$route.params.id, this.changed, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.dialog_cancel = false;
          alert("Cancelado com sucesso!");
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao cancelar!");
          console.log(error);
        });
    },
    dialogAuth: function(){
      this.changed.ipaddr = this.current.ipaddr;
      this.changed.ipport = this.current.ipport;
      this.changed.number = this.current.number;
      this.changed.password = this.current.password;
      this.dialog_auth = true;
    },
    putAuth: function(){
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .put("/sipline/auth/" + this.$route.params.id, this.changed, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.dialog_auth = false;
          alert("Autenticação alterada com sucesso!");
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao alterar autenticação!");
          console.log(error);
        });
    },
    dialogDisc: function(){
        this.changed.countryCode = this.current.countryCode;
        this.changed.areaCode = this.current.areaCode;
        this.changed.cli = this.current.cli;
        this.changed.dialplan = this.current.dialplan;
        this.dialog_disc = true;
    },
    putDisc: function(){
        var me = this;
        var token = localStorage.getItem("token");
        me.dialog_loading = true;
        api
        .put("/sipline/disc/" + this.$route.params.id, this.changed, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.dialog_disc = false;
          alert("Discagem alterada com sucesso!");
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao alterar discagem!");
          console.log(error);
        });
    },
    dialogACL: function(){
      this.changed.acl = this.current.acl;
      this.dialog_acl = true;
    },
    putACL: function(){
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .put("/sipline/acl/" + this.$route.params.id, this.changed, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.dialog_acl = false;
          alert("ACL alterada com sucesso!");
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao alterar ACL!");
          console.log(error);
        });
    },
    dialogFat: function(){
      this.changed.invoiceType = this.current.invoiceType;
      this.dialog_fat = true;
    },
    putFat: function(){
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .put("/sipline/invoice/" + this.$route.params.id, this.changed, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.dialog_fat = false;
          alert("Faturamento alterado com sucesso!");
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao alterar faturamento!");
          console.log(error);
        });
    },
    dialogMonthly: function(){
        this.changed.monthly = this.current.monthly;
        this.dialog_monthly = true;
    },
    putMonthly: function(){
        var me = this;
        var token = localStorage.getItem("token");
        me.dialog_loading = true;
        api
        .put("/sipline/monthly/" + this.$route.params.id, this.changed, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.dialog_monthly = false;
          alert("Mensalidade alterada com sucesso!");
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao alterar mensalidade!");
          console.log(error);
        });
    },
    dialogChannels: function(){
        this.changed.channels = this.current.channels;
        this.dialog_channels = true;
    },
    putChannels: function(){
        var me = this;
        var token = localStorage.getItem("token");
        me.dialog_loading = true;
        api
        .put("/sipline/channels/" + this.$route.params.id, this.changed, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.dialog_channels = false;
          alert("Canais alterados com sucesso!");
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao alterar canais!");
          console.log(error);
        });
    },
    dialogMaxregs: function(){
        this.changed.maxregs = this.current.maxregs;
        this.dialog_maxregs = true;
    },
    putMaxregs: function(){
        var me = this;
        var token = localStorage.getItem("token");
        me.dialog_loading = true;
        api
        .put("/sipline/maxregs/" + this.$route.params.id, this.changed, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.dialog_maxregs = false;
          alert("Máximo de registros alterados com sucesso!");
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao alterar registros!");
          console.log(error);
        });
    },
    dialogBlocks: function(){
        this.changed.blockVoip = this.current.blockVoip;
        this.changed.blockLandline = this.current.blockLandline;
        this.changed.blockMobile = this.current.blockMobile;
        this.changed.blockInternational = this.current.blockInternational;
        this.dialog_blocks = true;
    },
    putBlocks: function(){
        var me = this;
        var token = localStorage.getItem("token");
        me.dialog_loading = true;
        api
        .put("/sipline/permissions/" + this.$route.params.id, this.changed, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.dialog_blocks = false;
          alert("Bloqueios alterados com sucesso!");
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao alterar bloqueios!");
          console.log(error);
        });
    },
    dialogObs: function(){
        this.changed.obs = this.current.obs;
        this.dialog_obs = true;
    },
    putObs: function(){
        var me = this;
        var token = localStorage.getItem("token");
        me.dialog_loading = true;
        api
        .put("/sipline/obs/" + this.$route.params.id, this.changed, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.dialog_obs = false;
          alert("Observação alterada com sucesso!");
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao alterar observação!");
          console.log(error);
        });
    },
    formatDate: function (date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    }
  },
  watch: {
    searchClient: function (val) {
      var me = this;
      if (val.length != 3) return;
      var token = localStorage.getItem("token");
      api
        .get("/client/name/" + val, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.clients = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    searchPlan: function (val) {
      var me = this;
      if (val.length != 3) return;
      var token = localStorage.getItem("token");
      api
        .get("/plan/name/" + val, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.plans = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
  computed: {
    computedSetup: function () {
      return this.formatDate(this.current.setup);
    }
  }
};
</script>